/*
* Existing User Form
*
* Used for the form existing Loloi User would ask new login
* to this new site. Possibly call mu-app method to trigger
* login activate method.
**/

custom.existingUserForm = (() => {

  // Variables
  const formClassName = "js-existing-user-form";
  const errorClassName = `${formClassName}--error`;
  const statusClassName = `${formClassName}--status`;

  /**
   * errorHandler
   *
   * @param {string} msg - Error message to display
   *
   * When validation catches error, show error.
   */
  function errorHandler(msg="") {
    msg = (msg != "") ? msg : custom.forgotPassword.response.error;
    $(`.${formClassName}`).addClass("error");
    $(`.${errorClassName}`).html(`<li>${msg}</li>`);
  }

  /**
   * successHandler
   *
   * @param {string} msg - Succession message to display
   *
   * Once past the validation, show indication of notification email being sent.
   */
  function successHandler(msg="") {
    $(`.${formClassName}`).removeClass("error");
    $(`.${errorClassName}`).html("");

    $(`.${formClassName}`).addClass("hidden");
    $(`.${statusClassName}`).removeClass("hidden").text(msg);

    const data = {
      eventCategory: 'Sign In',
      eventAction: 'Link',
      eventLabel: "Email My Password"
    }
    custom.gtmDatalayer.gtmPush(data);
  }

  /**
   * forgotPasswordSubmit
   *
   * @param {object} form - Form DOM object
   * @param {string} email - Email address in input field
   *
   * Trigger the forgot password submission via Ajax.
   */
  function forgotPasswordSubmit(form=null) {
    custom.forgotPassword.submit(form, successHandler, errorHandler);
  }

  /**
   * validateUser
   *
   * @param {object} event - Form submit object
   *
   * This method validates if submitted email address is in SPARS record or not.
   */
  function validateUser(event=null) {
    event.preventDefault();
    const $form = $(event.target);
    const email = $form.serializeArray()[0].value;

    if (window.MUAPP.customerExists && window.MUAPP.activateUser) window.MUAPP.customerExists(email).then(res => {
      //res.spars_customer - user exists in spars
      //res.shopify_customer + res.shopify_id - user exists in shopify
      if (!res.shopify_customer) return errorHandler(`Email does not match our records. Please email <a class="text-red underline" href="mailto:customerservice@loloirugs.com?subject=I%20need%20assistance%20with%20a%20login%20to%20loloirugs.com">customerservice@loloirugs.com</a> for assistance.`);
      //if (window.MUAPP.flushCookie) window.MUAPP.flushCookie();
      return (res.shopify_customer_state == "enabled") ? forgotPasswordSubmit($form) : window.MUAPP.activateUser(res.shopify_id, () => successHandler(`We've sent an account invite to ${email}.`));
    });
  }

  function clearError(event) {
    $el = $(event.currentTarget);

    $el.closest(`.${formClassName}`)
      .removeClass('error')
      .find(`.${formClassName}--error`)
      .empty();
  }

  function init() {
    if ($(`.${formClassName}`).length > 0) {
      $(`.${formClassName}`).on("submit", validateUser);
      $(`.${formClassName} input`).on('keydown', clearError);
    }

  }

  return {
    init
  }

})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/existing-user-form.js